import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=5ec4f1f4&scoped=true&"
import script from "./UpdatePassword.vue?vue&type=script&lang=ts&"
export * from "./UpdatePassword.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=5ec4f1f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4f1f4",
  null
  
)

export default component.exports